module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vacancy":"0 jobs | {n} job | {n} jobs | {n} jobs","vacancies":"jobs","more":"More","companyVacancies":"Company jobs","companyInfo":"Company information"}}')
  delete Component.options._Ctor
}
